/* carousel.js — scroll-snap carousels with arrow buttons (products, reviews) */
(function () {
  'use strict';

  function initCarousel(root) {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    /* True item pitch, measured from two adjacent items rather than assuming a
       gap. The old `width + 14` was wrong for any track with a different gap
       (the category tiles use 32px), which made the animation land between snap
       points — it eased into place and then visibly popped when snapping
       re-engaged. */
    const step = () => {
      const items = track.querySelectorAll('.carousel__item');
      if (items.length >= 2) {
        const a = items[0].getBoundingClientRect();
        const b = items[1].getBoundingClientRect();
        const pitch = b.left - a.left;
        if (pitch > 1) return pitch;
      }
      const one = items[0];
      return one ? one.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
    };

    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* `scroll-snap-type: x mandatory` makes the browser jump straight to the
       nearest snap point, which cancels a native smooth scrollBy — the arrows
       teleported instead of sliding. Animate scrollLeft ourselves with snapping
       suspended for the duration, then hand control back so touch swipes still
       snap normally. */
    let raf = null;

    function slideBy(delta) {
      const max = track.scrollWidth - track.clientWidth;
      const from = track.scrollLeft;
      const pitch = step();
      /* Land exactly on an item boundary so restoring snap is a no-op — an
         unaligned target makes the browser correct the position afterwards,
         which reads as a pop at the end of an otherwise smooth slide. */
      let to = from + delta;
      if (pitch > 1) to = Math.round(to / pitch) * pitch;
      to = Math.max(0, Math.min(max, to));
      if (Math.abs(to - from) < 1) return;

      if (reduced()) {
        track.scrollLeft = to;
        return;
      }

      if (raf) cancelAnimationFrame(raf);
      const prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';

      const distance = to - from;
      const duration = Math.min(680, Math.max(320, Math.abs(distance) * 0.6));
      const start = performance.now();
      // easeOutCubic — quick departure, soft landing
      const ease = (t) => 1 - Math.pow(1 - t, 3);

      const tick = (now) => {
        const t = Math.min(1, (now - start) / duration);
        track.scrollLeft = from + distance * ease(t);
        if (t < 1) {
          raf = requestAnimationFrame(tick);
        } else {
          raf = null;
          track.style.scrollSnapType = prevSnap;
        }
      };
      raf = requestAnimationFrame(tick);
    }

    prev.addEventListener('click', () => slideBy(-step() * 2));
    next.addEventListener('click', () => slideBy(step() * 2));

    const updateArrows = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      next.toggleAttribute('disabled', track.scrollLeft >= max);
      const hide = track.scrollWidth <= track.clientWidth + 2;
      prev.hidden = hide;
      next.hidden = hide;
    };
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  const boot = () => document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init inside the theme editor when sections re-render
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-carousel]').forEach(initCarousel);
  });
})();
